<template lang="pug">

#webgl(v-if="!isWebGl")
  .qr
    img(src="~assets/qrcode.jpg")

  h1 {{ $t('unsupported') }}

</template>



<script>
import {mapState} from 'vuex'

export default {
  name: 'webgl',
  data () {
    return {

    }
  },
  computed: {
    ...mapState({
      isWebGl: state => state.browser.isWebGl
    })
  },
  mounted () {

  },
  methods: {

  }
}
</script>



<style lang="sass" scoped>
@import "src/common.sass"

#webgl
  +full()
  +flex-center()
  flex-direction: row
  background-color: $cl-red
  background-image: url('~assets/unsupported/bg.jpg')
  background-size: cover
  background-position: center
  z-index: 2001
  text-align: center
  color: white

  .qr
    margin-right: 2rem

  h1
    font-style: italic
    white-space: pre-line

</style>



// WEBPACK FOOTER //
// WebGl.vue?710c8ef4